import { cn } from "@fmc-digital/ui";
import { getSiteAdminUrl } from "@/utils";

export function AcpUnauthorizedBanner() {
  return (
    <div
      className={cn(
        "flex items-center gap-3 w-full bg-error-container rounded-2xl min-h-[40px] p-4",
      )}
      data-testid="acp-unauthorized-error-banner"
    >
      <div className="flex-shrink-0 w-5 h-5" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="10" className="fill-on-error-container" />
          <path
            d="M10 5V11"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="10" cy="14" r="1" fill="white" />
        </svg>
      </div>
      <span className="font-poppins font-normal tracking-[0.25px] flex-1 m-0 p-0 text-[12px] leading-4 lg:text-[14px] lg:leading-5 text-on-error-container">
        User is not authorized to use the Authenticated Customer Portal. Login using
        -{" "}
        <a
          href={getSiteAdminUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          Site-Admin
        </a>
      </span>
    </div>
  );
}
